import React from 'react'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import { REPORT_KEYS } from 'constants/reporting'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'

interface ILocationReportingProps {
  print?: boolean
  useCarrierFilters: boolean
}

const LocationReportingDashboard: React.FC<ILocationReportingProps> = (
  props
) => {
  const { useCarrierFilters } = props
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()

  const isAgentOrCarrier = isCarrierLogin() || isAgentLogin()
  const invitingCompanyId = isAgentOrCarrier
    ? ensuredInvitingCompanyId
    : undefined
  const carrierId =
    useCarrierFilters && !isCarrierLogin()
      ? localStorage.getItem('carrierId') || undefined
      : undefined
  return (
    <ConsoleEmbed
      reportKey={REPORT_KEYS.LOCATION}
      invitingCompanyId={invitingCompanyId}
      carrierId={carrierId}
      fullHeight={!useCarrierFilters}
    />
  )
}
export default LocationReportingDashboard
